<template>
  <div>
    <Header :text="'เข้าสู่ระบบ'" :headerImg="1"></Header>
    <div style="position: relative">
      <div class="content">
        <div class="wrapper pt-6">
          <h6 class="primary-title">
            <span>Enter PIN Number</span>
          </h6>
          <div class="pt-4 custom-font">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(verifyPin)">
                <div class="text-center pt-8">
                  <ValidationProvider
                    name="รหัส PIN"
                    :rules="{
                      required: true,
                      min: 6,
                      numeric: true
                    }"
                    v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      :success="valid"
                      :error-messages="errors"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      type="password"
                      placeholder="PIN number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength="6"
                      v-model="input.pin"
                      :hide-details="errors.length ? false : true"
                      style="border-radius: 0px"
                      label="PIN number"
                      color="blue"
                    ></v-text-field>
                  </ValidationProvider>
                </div>
                <div class="text-center mt-4">
                  <v-progress-circular
                    v-if="forgetloading"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <a v-else @click="forgetPin">Forget PIN</a>
                  <div class="mx-5" style="margin-top: 80px">
                    <v-btn
                      type="submit"
                      width="200px"
                      :disabled="loading"
                      :loading="loading"
                      height="45px"
                      dark
                      class="primary-btn"
                      >LOGIN</v-btn
                    >
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import axios from 'axios'
import queryString from 'query-string'

export default {
  components: {
    Header
  },
  data() {
    return {
      forgetloading: false,
      query: '',
      loading: false,
      serverUrl: 'https://api-summit-cap.zwiz.app/',
      input: {
        pin: ''
      }
    }
  },
  computed: {
    token() {
      if (this.query.apptype == 'line') {
        return '830BE6D6-C4DA-410A-93EC-6634F5AE0457'
      } else {
        return '1AB1187F-5699-4E90-A6D7-1CEBDCA13E2B'
      }
    },
    transid() {
      var d = new Date()
      var day = d.getDate() + ''
      var month = d.getMonth() + 1 + ''
      var year = d.getFullYear() + ''
      var hour = d.getHours() + ''
      var minute = d.getMinutes() + ''
      var second = d.getSeconds() + ''
      var mills = d.getMilliseconds() + ''
      var defaultFill = '00'

      mills = (defaultFill + mills).substr(mills.length)

      if (day.length < 2) day = '0' + day

      if (month.length < 2) month = '0' + month

      if (hour.length < 2) hour = '0' + hour

      if (minute.length < 2) minute = '0' + minute

      if (second.length < 2) second = '0' + second

      return year + month + day + hour + minute + second + mills
    },
    userid() {
      if (this.query.apptype == 'line') {
        return this.$store.state.profile.userId
      } else {
        return this.simplifyArray(this.query.userid).split('__')[0]
      }
    }
  },
  async mounted() {
    try {
      await this.queryinit()
    } catch (error) {
      await this.handleSentLog(
        `[ERROR LIFF (Login.vue)]: [function mounted()] ${this.getErrorMessage(error)}`
      )
      throw error
    }
  },
  methods: {
    async backTo() {
      try {
        if (this.query && this.query.back_to) {
          const { back_to, ...etc } = this.query
          this.$router.push({
            path: '/',
            query: { ...etc, view: this.query.back_to }
          })
          location.reload()
        }
      } catch (error) {
        await this.handleSentLog(
          `[ERROR LIFF (Login.vue)]: [function backTo()]: ${this.getErrorMessage(error)}`
        )
      }
    },
    async forgetPin() {
      try {
        this.forgetloading = true
        var vm = this
        var userid
        if (this.query.apptype == 'line') {
          userid = this.userid + '__' + this.pageid
        } else {
          userid = this.userid
        }
        axios
          .get(this.serverUrl + `summitidcard?userid=${userid}&pageid=${this.pageid}`, {
            headers: {
              AUTHORIZATION: 'Bearer xxx xxx'
            }
          })
          .then(async (response) => {
            vm.forgetloading = false
            if (response.data.responsecode == 200) {
              var idcard = response.data.idcard
              await vm.$router.replace({
                path: vm.$route.path,
                query: {
                  ...vm.$route.query,
                  idcard: idcard,
                  view: 'register'
                }
              })
            } else {
              await this.handleSentLog(
                `[ERROR LIFF (Login.vue)]: [function forgetPin()] Status Code Not Equal 200 = ${response.data.responsecode}`
              )
              await vm.$swal.fire({
                icon: 'error',
                text: 'ข้อมูลไม่ถูกต้อง'
              })
            }
          })
          .catch(async (error) => {
            await this.handleSentLog(
              `[ERROR LIFF (Login.vue)]: [function forgetPin()] Catch Error Axios ${this.getErrorMessage(
                error
              )}`
            )
            await vm.$swal.fire({
              icon: 'error',
              text: 'ข้อมูลไม่ถูกต้อง'
            })
          })
      } catch (error) {
        await this.handleSentLog(
          `[ERROR LIFF (Login.vue)]: [function forgetPin()] ${this.getErrorMessage(error)}`
        )
      }
    },
    async queryinit() {
      try {
        var vm = this
        const rawState = vm.$route.query['liff.state']
        if (rawState) {
          const decoded = decodeURIComponent(rawState)
          const cleaned = decoded.replace(/^\//, '').replace(/^\?/, '')
          const state = queryString.parse(cleaned)
          vm.query = this.cleanObject(state)
        } else {
          vm.query = this.cleanObject(vm.$route.query)
        }
        if (vm.query.pageid) vm.pageid = vm.query.pageid
      } catch (error) {
        await this.handleSentLog(
          `[ERROR LIFF (Login.vue)]: [function queryinit()] ${this.getErrorMessage(error)}`
        )
      }
    },
    async handleSentLog(message) {
      try {
        const payload = {
          liffProfile: this.$store.state.profile,
          message,
          query: this.query,
          link: window.location.href
        }
        await this.postLogApi(payload)
      } catch (error) {
        alert('Error: Login Log' + this.getErrorMessage(error))
      }
    },
    async verifyPin() {
      try {
        var vm = this
        this.loading = true
        var data = {
          lineid: this.userid,
          pin: this.input.pin,
          transid: this.transid,
          token: vm.token
        }
        axios
          .post(this.$store.state.summitServer + 'API/ManagePinInfo/VerifyPinLineId', data)
          .then(async (response) => {
            this.loading = false
            if (response.data.status.status == 200) {
              await this.handleSentLog(
                `[DEBUG LIFF (Login.vue)]: [function verifyPin()] verify pin success`
              )
              if (vm.query.apptype == 'line') {
                try {
                  await this.$store.dispatch('sendMessage', {
                    userId: this.userid + '__' + this.pageid,
                    pageId: this.pageid,
                    message: 'E-service logged'
                  })
                } catch (error) {
                  await this.handleSentLog(
                    `[ERROR LIFF (Login.vue)]: [function verifyPin()] User has not granted required LINE permissions`
                  )
                }
                if (this.query && this.query.back_to) {
                  vm.backTo()
                } else {
                  vm.$liff.closeWindow()
                }
              } else if (vm.query.apptype == 'facebook') {
                var response = await axios.get(vm.serverUrl + 'checkpinlineid', {
                  params: {
                    userid: vm.userid,
                    pageid: vm.query.pageid,
                    pin: vm.input.pin
                  },
                  headers: { AUTHORIZATION: 'Bearer xxx xxx' }
                })
                if (this.query && this.query.back_to) {
                  vm.backTo()
                } else {
                  MessengerExtensions.requestCloseBrowser(
                    function success() {},
                    function error() {
                      window.close()
                    }
                  )
                }
              }
            } else {
              await this.handleSentLog(
                `[ERROR LIFF (Login.vue)]: [function verifyPin()] Status Code Not Equal 200 = ${response.data.status.status}`
              )
              await vm.$swal.fire({
                icon: 'error',
                text: 'ข้อมูลไม่ถูกต้อง'
              })
            }
          })
          .catch(async (error) => {
            await this.handleSentLog(
              `[ERROR LIFF (Login.vue)]: [function verifyPin()] Catch Error Axios ${this.getErrorMessage(
                error
              )}`
            )
            await vm.$swal.fire({
              icon: 'error',
              text: 'ข้อมูลไม่ถูกต้อง'
            })
          })
      } catch (error) {
        await this.handleSentLog(
          `[ERROR LIFF (Login.vue)]: [function verifyPin()] ${this.getErrorMessage(error)}`
        )
      }
    }
  }
}
</script>
